import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Colours from '../../definitions/Colours';


function IconFilters({ outlineWidth, stroke, strokeWidth, fill, ...otherProps }) {
    return (
        <IconFilters.Svg
            viewBox="0 0 62 62"
            outlineWidth={outlineWidth}
            strokeColour={stroke}
            strokeWidth={strokeWidth}
            fillColour={fill}
            {...otherProps}
        >
            <circle
                className="outline"
                cx="31"
                cy="31"
                r="29"
            />
            <path d="M19.79 44.77V33.43M19.79 27.41V16.17M42.47 44.77V28.01M42.47 21.89v-5.72M31.13 44.77v-5.42M31.13 33.33V16.17" />
            <circle
                cx="31.13"
                cy="36.39"
                r="2.96"
            />
            <circle
                cx="42.47"
                cy="25.05"
                r="2.96"
            />
            <path d="M22.75 30.47a2.96 2.96 0 11-5.92 0 2.96 2.96 0 015.92 0z" />
        </IconFilters.Svg>
    );
}

IconFilters.propTypes = {
    outlineWidth: PropTypes.string,
    stroke: PropTypes.oneOf(
        Object.values(Colours),
    ),
    strokeWidth: PropTypes.string,
    fill: PropTypes.oneOf(
        Object.values(Colours),
    ),
};

IconFilters.defaultProps = {
    outlineWidth: '2px',
    stroke: Colours.BLACKBERRY,
    strokeWidth: '2px',
    fill: Colours.TRANSPARENT,
};

IconFilters.Svg = styled.svg`
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: ${props => props.strokeWidth};
    stroke: ${props => props.strokeColour};
    fill: ${props => props.fillColour};

    transform: rotate(90deg);

    circle.outline {
        stroke-width: ${props => props.outlineWidth};
    }

    transition:
        stroke 300ms ease,
        fill 300ms ease;
`;

export default IconFilters;
